<div class="container">
  <div class="animation-container vertical" [class.open]="focusSelectionPopupVisible()">
    <div class="selection-container vertical" *ngIf="focusSelectionPopupVisible()">
      <div *ngFor="let focusElement of _focusElements()" class="selection-button-container">
        <button (click)="setFocus($event, focusElement)" [class.active]="isActivFocusElement(focusElement)">
          {{ focusElement.label }}
        </button>
        <div class="spacer" *ngIf="getLastFocusElementIdentifier() !== focusElement.identifier"></div>
      </div>
    </div>
  </div>
  <div class="buttons-container">
    <div *ngIf="showZoomButtons" class="zoom-button-container" [ngClass]="{'first-button': getFirstButton() === buttonTypeEnum.ZoomButton, 'last-button': getLastButton() === buttonTypeEnum.ZoomButton}">
      <div class="center-button-container">
        <button class="main-button" (click)="zoomIn($event)" [disabled]="mapComponent.map.googleMap.getZoom() >= maxZoom" [title]="zoomInLabel | translate" [ngClass]="{'first-button': getFirstButton() === buttonTypeEnum.ZoomButton}">
          <qpoint-icon [icon]="'plus'" ></qpoint-icon>
        </button>
        <div class="spacer"></div>
        <button class="main-button" (click)="zoomOut($event)" [disabled]="mapComponent.map.googleMap.getZoom() <= minZoom" [title]="zoomOutLabel | translate" [ngClass]="{'last-button': getLastButton() === buttonTypeEnum.ZoomButton}">
          <qpoint-icon [icon]="'minus'"></qpoint-icon>
        </button>
        <div class="spacer" *ngIf="showFitBoundsButton || _showFocusButton()"></div>
      </div>
    </div>
    <div class="fit-bounds-button-container" *ngIf="showFitBoundsButton">
      <div class="animation-container" [class.open]="fitBoundsSelectionPopupVisible()">
        <div class="selection-container" *ngIf="fitBoundsSelectionPopupVisible()">
          <button class="overview-button" (click)="setOverviewFitBounds($event)" [title]="overviewLabel | translate" [class.active]="_activeFitBounds() === fitBoundsEnum.Overview">
            {{overviewLabel | translate}}
          </button>
          <div class="vertical-spacer"></div>
          <button class="location-button" (click)="setLocationFitBounds($event)" [title]="locationLabel | translate" [class.active]="_activeFitBounds() === fitBoundsEnum.Location">
            {{locationLabel | translate}}
          </button>
        </div>
      </div>
      <div class="center-button-container">
        <button class="main-button" (click)="fitBoundsChanged.observed ? toggleFitBoundsSelectionPopup($event) : fitBounds($event)" [title]="fitBoundsLabel | translate" [ngClass]="{'first-button': getFirstButton() === buttonTypeEnum.FitBoundsButton, 'last-button': getLastButton() === buttonTypeEnum.FitBoundsButton}">
          <qpoint-icon [icon]="'arrows-to-dot'"></qpoint-icon>
        </button>
        <div class="spacer" *ngIf="_showFocusButton()"></div>
      </div>
    </div>
    <div class="focus-button-container" *ngIf="_showFocusButton()">
      <div class="center-button-container">
        <button class="main-button" (click)="toggleFocusSelectionPopup($event)" [title]="focusButtonToolTip | translate"
          [ngClass]="{'first-button': getFirstButton() === buttonTypeEnum.FocusButton, 'last-button': getLastButton() === buttonTypeEnum.FocusButton}">
          <qpoint-icon [icon]="'arrows-to-dot'"></qpoint-icon>
        </button>
      </div>
    </div>
  </div>
</div>